import { IInfinitePageParams, IInfinitePageResponse } from 'services/types';

export enum PRODUCT_TYPE {
  Digital = 1,
  Physical = 2,
  Merch = 3,
  YouTube = 4,
}

export enum CONTRACT_STATUS {
  unknown = -1,
  offer = 1,
  active = 2,
  withdraw = 3,
  rejected = 4,
}

export interface IContractListItemResponse {
  id: string;
  status: CONTRACT_STATUS;
  labelId: string;
  title: string;
  sendStatus: CONTRACT_STATUS;
  startDate: string;
  endDate: string;
}

export interface IContractListResponse extends IInfinitePageResponse<IContractListItemResponse> {}

export interface IContractSearch {
  ShowOnlyActive?: boolean;
  ProductType?: PRODUCT_TYPE;
}

export interface IContractListParams extends IInfinitePageParams, IContractSearch {}

export interface IDistributionShareBase {
  salesChannelId: string;
  salesChannelName: string;
  percent: number;
}

export interface IDistributionShareWithAmount extends IDistributionShareBase {
  amountPerUnit: number;
}

export interface IContractDistributionShareResponse {
  salesChannelId: string;
  salesChannelName: string;
  percent: number;
  amountPerUnit?: number;
}

export interface IContractDistributionSection {
  title: string;
  position: number;
  defaultSharePercentage: number;
  shares: IContractDistributionShareResponse[];
}

export interface IContractDistributionSectionWithAmount extends IContractDistributionSection {
  defaultAmountPerUnit?: number;
}

export interface IContractCustomSectionAgreement {
  position: number;
  title: string;
  value: string;
  mode: number;
}

export interface IContractCustomSectionType {
  name: string;
  id: number;
}

export interface IContractCustomSection {
  position: number;
  title: string;
  type: IContractCustomSectionType;
  agreement: IContractCustomSectionAgreement[];
  customSections?: IContractCustomSection[];
}

export type IContractDisplaySection =
  | {
      type: 'distribution';
      title: string;
      position: number;
      data: IContractDistributionSection | IContractDistributionSectionWithAmount;
    }
  | {
      type: 'custom';
      title: string;
      position: number;
      data: IContractCustomSection;
    };

export interface IContractResponse {
  id: string;
  labelId: string;
  labelName: string;
  title: string;
  sendStatus: number;
  status: number;
  version: number;
  startDate: string;
  endDate: string | null;
  digitalDistributionSection: IContractDistributionSection | null;
  physicalDistributionSection: IContractDistributionSectionWithAmount | null;
  merchDistributionSection: IContractDistributionSectionWithAmount | null;
  channelDistributionSection: IContractDistributionSection | null;
  costDistributionSection: IContractDistributionSection | null;
  customSections: IContractCustomSection[];
  sortedSections?: IContractDisplaySection[];
}

// produkty

export interface IContractProductType {
  name: string;
  id: number;
}

export interface IContractProduct {
  id: string;
  title: string;
  ean: string;
  productType: IContractProductType;
}

// tracki

export interface IContractTrackMainTitle {
  title: string;
  version: string;
  language: number;
}

export interface IContractTrack {
  id: string;
  mainTitle: IContractTrackMainTitle;
  isrc: string;
}

// video

export interface IContractVideoTitle {
  title: string;
  version: string;
  language: number;
}

export interface IContractVideoLine {
  name: string;
  year: number;
}

export interface IContractVideoExternalId {
  id: string;
  type: string;
  link: string;
}

export interface IContractVideoGenre {
  name: string;
  id: number;
}

export interface IContractVideoSubtitle {
  subtitles: string;
  language: number;
}

export interface IContractVideoOtherTitle {
  title: string;
  version: string;
  language: number;
}

export interface IContractVideoArtist {
  id: string;
  nickname: string;
  role: number;
  rolePlacement: number;
}

export interface IContractVideoContract {
  id: string;
  contractId: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  labelId: string;
  labelName: string;
  divisionPercentage: number;
  contractName: string;
}

export interface IContractVideo {
  version: number;
  id: string;
  mainTitle: IContractVideoTitle;
  videoTitle: string;
  pline: IContractVideoLine;
  cline: IContractVideoLine;
  isrc: string;
  censorious: number;
  videoStatus: number;
  externalIds: IContractVideoExternalId[];
  source: number;
  language: number;
  genre: IContractVideoGenre;
  videoLink: string;
  originalVideoLink: string;
  instrumental: boolean;
  isCreatedWithAi: boolean;
  hasDuplicatedArtist: boolean;
  otherTitles: IContractVideoOtherTitle[];
  subtitles: IContractVideoSubtitle[];
  artists: IContractVideoArtist[];
  canUpdateISRC: boolean;
  contracts: IContractVideoContract[];
}

export interface IAcceptOrRejectContractRequest {
  accountId?: string;
  contractId: string;
  code?: string;
}
